import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosPagosPagoItemComponent {
  colores = {
    '1': '#B4045F',
    '2': '#01A9DB',
  }
  data
  pagando = false
  tipo_id = {
    '1': 'Anticipo',
    '2': 'Reembolso',
  }
  title = ''
  onChange

  constructor ($state, ViaticosPagosPagoPagarService, ViaticosPagosRealizadosService) {
    this.ViaticosPagosPagoPagarService = ViaticosPagosPagoPagarService
    this.ViaticosPagosRealizadosService = ViaticosPagosRealizadosService
    this.$state = $state
  }

  $onInit () {
    this.setTitle()
  }

  goToViatico () {
    this.$state.go('.viatico', {folio: this.data.folio})
  }

  configurar () {
    this.mostrar = !this.mostrar
  }

  getPago (pago) {
    this.mostrar = false
    this.data.pago = Object.assign(this.data.pago || {}, pago)
    this.setTitle()
    this.onChange({$event: {detail: this.data}})
  }

  pagar () {
    if (this.pagando || !this.data.pago) return
    this.pagando = true
    const servicio = this.data.pago.id_pago ? this.ViaticosPagosPagoPagarService : this.ViaticosPagosRealizadosService
    servicio.post(this.data.folio, this.data.indice, this.data.pago)
      .then(({data}) => {
        this.pagando = false
        this.data.pago = Object.assign(this.data.pago, data)
        this.onChange({$event: {detail: this.data}})
      })
  }

  setTitle () {
    if (!this.data.pago) {
      this.title = 'Pago sin cofigurar'
    } else if (this.data.pago.id_pago && !this.data.pago.status_pagado) {
      this.title = 'Pago configurado, pendiente de aplicar'
    } else if (this.data.pago.id_pago && this.data.pago.status_pagado) {
      this.title = 'Pago aplicado'
    }
  }
}

module.component('viaticosPagosPagoItem', {
  controller: ViaticosPagosPagoItemComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/pagos/pago/item/component.js